<!-- 휴일 등록/수정 모달 -->
<template>
    <b-modal
        v-model="visible"
        :title="viewTitle"
        size="lg"
        centered
        no-close-on-backdrop
        hide-footer
        no-enforce-focus
        ref="modal"
        @hidden="onHidden"
    >
        <vvo v-slot="v">
            <div v-if="detailInfo">
                <div class="d-flex align-items-center mb-3" v-if="!isNewMode">
                    <span class="badge badge-secondary mr-2">{{ detailInfo.holiIdx }}</span>
                    <span class="badge badge-info mr-auto">{{ getHoliTypeCodeName(detailInfo.holiTypeCode) }}</span>
                    <b-form-checkbox switch v-model="isEditMode" size="lg" />
                </div>
                <div class="row" style="margin-bottom: 16px">
                    <div class="col-md-4">
                        <label for="holiName">
                            <span>{{ $t("휴일명") }}</span>
                            <i class="material-icons ml-1" :style="{ fontSize: '0.8rem' }">check_circle</i>
                        </label>
                        <valid-input
                            :vid="'휴일명'"
                            :classList="'form-control'"
                            :inputType="'text'"
                            :inputValue.sync="detailInfo.holiName"
                            :placeholder="$t('휴일명')"
                            :rules="rules.HOLIDAY_NAME_RULE"
                            :errorMessage="validMessage.COMMON_BOTH_LENGTH_VALID_MESSAGE(1, 30)"
                            :disabled="!isEditMode"
                        ></valid-input>
                    </div>
                    <div class="col-md-4">
                        <label for="holiTypeCode">
                            <span>{{ $t("휴일 구분") }}</span>
                            <i class="material-icons ml-1" :style="{ fontSize: '0.8rem' }">check_circle</i>
                        </label>
                        <select
                            v-model="detailInfo.holiTypeCode"
                            :disabled="true"
                            id="holiTypeCode"
                            class="form-control"
                        >
                            <option value="">{{ $t("선택") }}</option>
                            <option v-for="(code, index) in holiTypeCodeList" :key="index" :value="code.smallCode">
                                {{ code.smallCodeName }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label for="baseDate">
                            <span>{{ $t("기준일자") }}</span>
                            <i class="material-icons ml-1" :style="{ fontSize: '0.8rem' }">check_circle</i>
                        </label>
                        <b-form-datepicker
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                            :placeholder="$t('날짜를 선택하세요.')"
                            locale="ko"
                            v-model="detailInfo.baseDate"
                            class="mb-2"
                            :disabled="!isEditMode"
                        ></b-form-datepicker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <label for="holiDesc">{{ $t("비고") }}</label>
                        <valid-textarea
                            :vid="'비고'"
                            :inputType="'text'"
                            :inputValue.sync="detailInfo.holiDesc"
                            :NonStatus="true"
                            :rules="rules.HOLIDAY_ETC_RULE"
                            :errorMessage="validMessage.COMMON_OVER_LENGTH_VALID_MESSAGE(100)"
                            :classList="'form-control'"
                            :disabled="!isEditMode"
                        ></valid-textarea>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-4" style="gap: 8px">
                    <button type="button" class="btn btn-primary" v-if="isEditMode" @click="onValidate(v, saveData)">
                        저장
                    </button>
                    <button
                        type="button"
                        class="btn btn-danger"
                        v-if="detailInfo.holiIdx && !isEditMode"
                        @click="deleteData"
                    >
                        삭제
                    </button>
                    <button type="button" class="btn btn-secondary" @click="clearData">닫기</button>
                </div>
            </div>
        </vvo>
    </b-modal>
</template>
<script>
import backEndApi from "@src/api/backEndApi";
import moment from "moment";
import * as popupMessages from "@src/consts/popupMessageConsts";
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts";
import ValidTextarea from "../../../components/validate-input/Valid-textarea.vue";

export default {
    components: { ValidTextarea },
    props: ["title", "holiTypeCodeList"],
    async created() {},
    mounted() {},
    data() {
        return {
            visible: false,
            detailInfo: null,
            mode: "view", // 편집모드 : edit/view/new
            popupMessages,
            rules,
            validMessage,
        };
    },
    computed: {
        isEditMode: {
            get() {
                return this.mode == "edit" || this.mode == "new";
            },
            set(value) {
                this.mode = value ? "edit" : "view";
            },
        },
        isNewMode() {
            return this.mode === "new";
        },
        isViewMode() {
            return this.mode === "view";
        },
        viewTitle() {
            return this.title || "휴일";
        },
    },
    methods: {
        // list-Detail Data Functions
        newData(baseDate, defaultHoliTypeCode = "") {
            this.mode = "new";
            this.visible = true;
            this.detailInfo = {
                holiIdx: null,
                baseDate: baseDate || "",
                holiTypeCode: defaultHoliTypeCode,
                holiName: "",
                holiDesc: "",
            };

            return this.detailInfo;
        },

        loadDataFromRow(rowData) {
            try {
                // Transform row data to detailInfo format
                this.detailInfo = {
                    holiIdx: rowData.holiIdx,
                    baseDate: rowData.baseDate || "",
                    holiTypeCode: rowData.holiTypeCode || "",
                    holiName: rowData.holiName || "",
                    holiDesc: rowData.holiDesc || "",
                    regDate: rowData.regDate ? moment(rowData.regDate).format("YYYY-MM-DD HH:mm:ss") : null,
                    modDate: rowData.modDate ? moment(rowData.modDate).format("YYYY-MM-DD HH:mm:ss") : null,
                    regWorker: rowData.regWorker || null,
                };
                this.mode = "view";
                this.visible = true;
            } catch (e) {
                console.error(e);
                this.alertNoti(popupMessages.COMMON_NO_SEARCH_DATA_POPUP_MESSAGE);
            }
        },

        clearData() {
            // detailInfo는 모달이 완전히 닫힌 뒤(@hidden) 비운다
            this.visible = false;
        },

        getHoliTypeCodeName(holiTypeCode) {
            if (!this.holiTypeCodeList || !holiTypeCode) return "";
            const code = this.holiTypeCodeList.find((c) => c.smallCode === holiTypeCode);
            return code ? code.smallCodeName : holiTypeCode;
        },

        async saveData() {
            try {
                // Validate required fields
                if (!this.detailInfo.holiTypeCode) {
                    this.alertWarning(popupMessages.HOLIDAY_DIVISION_VALID_POPUP_MESSAGE || "휴일구분을 선택해주세요.");
                    return;
                }
                if (!this.detailInfo.baseDate) {
                    this.alertWarning(
                        popupMessages.HOLIDAY_SEARCH_PERIOD_VALID_POPUP_MESSAGE || "기준일자를 선택해주세요."
                    );
                    return;
                }

                // Prepare data for API (array format)
                const holidayData = [this.detailInfo];

                let result = await backEndApi.calendar.insertHoliday(holidayData);
                if (result.status == 200 && result.data && result.data.length > 0) {
                    await this.alertNoti(popupMessages.COMMON_SAVE_POPUP_MESSAGE);

                    // Update detailInfo with returned data
                    if (result.data[0]) {
                        this.detailInfo = {
                            ...this.detailInfo,
                            ...result.data[0],
                        };
                    }

                    this.$emit("data-updated", this.isNewMode ? "insert" : "update", this.detailInfo);
                    this.clearData();
                } else {
                    this.alertWarning(
                        `${result.data?.message || "저장에 실패했습니다."}`,
                        "",
                        `${typeof result.data?.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
                this.alertDanger(popupMessages.COMMON_SAVE_ERROR_POPUP_MESSAGE || "저장 중 오류가 발생했습니다.");
            }
        },

        async deleteData() {
            if (!this.detailInfo || !this.detailInfo.holiIdx) {
                return;
            }

            const result = await this.alertConfirmWarning(popupMessages.COMMON_DELETE_CONFIRM_POPUP_MESSAGE);
            if (!result.value) return;

            const deletedHoliIdx = this.detailInfo.holiIdx;

            try {
                const param = [deletedHoliIdx];
                const result = await backEndApi.calendar.deleteHoliday(param);
                if (result.status == 200 && result.data > 0) {
                    this.clearData();
                    this.$emit("data-updated", "delete", deletedHoliIdx);

                    this.alertNoti(popupMessages.COMMON_DELETE_POPUP_MESSAGE);
                } else {
                    this.alertWarning(
                        `${result.data?.message || "삭제에 실패했습니다."}`,
                        "",
                        `${typeof result.data?.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
                this.alertDanger(popupMessages.COMMON_REMOVE_ERROR_POPUP_MESSAGE || "삭제 중 오류가 발생했습니다.");
            }
        },

        getData() {
            return this.detailInfo;
        },

        // Private Event Handling Functions
        onHidden() {
            this.detailInfo = null;
            this.mode = "view";
        },
    },
};
</script>

<style scoped>
/* detail area styles */
.detail-placeholder {
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.detail-notification-icon {
    padding: 1rem;
    color: #444;
    font-size: 48px;
}

.detail-notification-text {
    font-size: 15px;
    font-weight: bold;
}

.detail-container {
    height: 100%;
    width: 100%;
    padding: 1rem 1rem 1rem 1rem;
    border-radius: 10px;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    font-size: 12px;
}

.detail-header {
    margin-bottom: 0px !important;
    padding: 8px 16px 8px 16px;
    overflow: hidden;

    display: flex;
    justify-content: space-between;
    align-items: center;

    border-radius: 6px 6px 0px 0px;
    background-color: #f1f1f1;
    border: solid #ececec 1px;
    border-bottom: 1px solid #ccc;
    font-weight: bold;
}

.detail-header .detail-title {
    padding: 0 !important;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

.detail-content {
    height: Calc(100% - 50px);

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    margin-top: 2px;
    padding: 20px;
    overflow-y: auto;
    background-color: white;
    border: solid #ececec 1px;
    border-radius: 0px 0px 6px 6px;
}

.detail-control {
    margin-bottom: 8px !important;
    display: flex;
    justify-content: flex-end;
}

.detail-bottom {
    margin-top: auto;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 10px;
}

.detail-bottom-buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;

    margin-top: 4px;
}

.detail-btn {
    flex: 1;
    min-width: 80px;
}

.detail-bottom-info {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 8px 4px 8px;
}

/* input form styles */
.title {
    font-weight: 600;
    margin-right: 20px;
}

/* Badge styles */
.badge {
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
    display: inline-block;
    min-width: 20px;
    padding: 0px 10px 0px 10px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    line-height: 22px;
    border-radius: 8px;
}

.badge.title1 {
    background-color: #ff6d00;
    color: #fff;
}

.badge.title2 {
    background-color: #546e7a;
    color: #fff;
}

.badge.others {
    background-color: #cfd8dc;
    color: #000;
}

.row {
    margin-bottom: 16px;
}
</style>
